import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

import { environment } from 'src/environments/environment';

/**
 * Transforms an arbitrary array into a PrimeNG `SelectItem[]` for use in
 * `p-dropdown` and `p-listbox`.  Each element is mapped to
 * `{ label: item[labelProperty], value: item }`.
 */
@Pipe({
  name: 'pipeselecteditems'
})
export class PipeselecteditemsPipe implements PipeTransform {

  /** @param value Array of objects to transform. @param labelProperty Property name to use as the display label. */
  transform(value: any, labelProperty: string): SelectItem[] {
    if (value) {
      true || environment.production || console.log('*** Pipe: ');
      return value.map(function (item) {
        return {
          label: item[labelProperty],
          value: item
        }
      });
    }
    else return [];
  }

}

/** Trims leading and trailing whitespace from a string value; returns `''` for falsy input. */
@Pipe({
  name: 'pipetrimstr'
})
export class PipeTrimStr implements PipeTransform {

  /** @param value String to trim. */
  transform(value: string): string {
    if (value) {
      true || environment.production || console.log('*** Pipe trim(): ');
      return value.trim();
    }
    else return '';
  }

}
